import { validationMessages, validationValues } from 'helpers/form';
import { DayOfMonth, JobFrequency } from 'types/Job';
import * as yup from 'yup';

export const DAY_OF_WEEK_REQUIRED: string = 'Please select day of week';
export const JOB_NAME_REQUIRED: string = 'Please enter a job name';
export const FREQUENCY_REQUIRED: string = 'Please select a frequency';
export const TIME_REQUIRED: string = 'Please enter a time';
export const BENCHMARKS_REQUIRED: string = 'Please select a benchmark';
export const TIME_PERIOD_REQUIRED: string = 'Please enter a time period';
export const START_DATE_REQUIRED: string = 'Please select start date';
export const END_DATE_REQUIRED: string = 'Please select end date';
export const DAY_OF_MONTH_REQUIRED: string = 'Please select day of month';

export const DAY_OF_MONTH_OPTIONS = () => {
  let options: any = Array(29).keys();
  options = [...options];
  options[0] = DayOfMonth.EndOfMonth;
  return options;
};

export const createJobValidationSchema = yup.object({
  recurring: yup.boolean(),
  name: yup
    .string()
    .trim()
    .when('recurring', {
      is: (recurring: boolean) => recurring,
      then: (schema) => schema.required(JOB_NAME_REQUIRED),
    }),
  jobFrequencyId: yup.number().when('recurring', {
    is: (recurring: boolean) => recurring,
    then: (schema) => schema.required(FREQUENCY_REQUIRED),
  }),
  time: yup.string().when('recurring', {
    is: (recurring: boolean) => recurring,
    then: (schema) => schema.required(TIME_REQUIRED),
  }),
  benchmarkIds: yup
    .array()
    .of(yup.string())
    .required(BENCHMARKS_REQUIRED)
    .min(1, validationMessages.required),
  numberOfQuartersBack: yup
    .number()
    .integer(validationMessages.integer)
    .typeError(validationMessages.required)
    .when('recurring', {
      is: (recurring: boolean) => recurring,
      then: (schema) =>
        schema
          .typeError(TIME_PERIOD_REQUIRED)
          .required(TIME_PERIOD_REQUIRED)
          .moreThan(0, validationMessages.greaterThanZero)
          .max(validationValues.maxInteger, validationMessages.numberTooLarge),
      otherwise: (schema) => schema.nullable(true),
    }),
  startDate: yup.string().when('recurring', {
    is: (recurring: boolean) => !recurring,
    then: (schema) =>
      schema.typeError(START_DATE_REQUIRED).required(START_DATE_REQUIRED),
  }),
  endDate: yup.string().when('recurring', {
    is: (recurring: boolean) => !recurring,
    then: (schema) =>
      schema.typeError(END_DATE_REQUIRED).required(END_DATE_REQUIRED),
  }),
  dayOfTheWeek: yup
    .number()
    .typeError(validationMessages.required)
    .when('jobFrequencyId', {
      is: (jobFrequencyId: number) => jobFrequencyId === JobFrequency.Weekly,
      then: (schema) =>
        schema
          .min(1, DAY_OF_WEEK_REQUIRED)
          .max(7, DAY_OF_WEEK_REQUIRED)
          .typeError(DAY_OF_WEEK_REQUIRED)
          .required(DAY_OF_WEEK_REQUIRED),
      otherwise: (schema) => schema.nullable(true),
    }),
  dayOfMonth: yup
    .number()
    .typeError(validationMessages.required)
    .when('jobFrequencyId', {
      is: (jobFrequencyId: number) => jobFrequencyId === JobFrequency.Monthly,
      then: (schema) =>
        schema
          .oneOf(DAY_OF_MONTH_OPTIONS(), DAY_OF_MONTH_REQUIRED)
          .typeError(DAY_OF_MONTH_REQUIRED)
          .required(DAY_OF_MONTH_REQUIRED),
      otherwise: (schema) => schema.notRequired(),
    }),
});
